import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        // PlpInstaStory
        container: {
            position: 'relative',
            overflow: 'hidden',
            cursor: 'pointer',
            touchAction: 'pan-y',
            w: '100%',
            h: '100%',
            minH: remCalc(460),
            bg: 'background.default',
        },
        contentContainer: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            flexDirection: 'column',
            zIndex: 3,
            pointerEvents: 'none',
            p: remCalc(12),
            gap: remCalc(20),
        },
        headerContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(8),
        },
        heading: {
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
        },
        bodycopy: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        progressBar: {
            gap: remCalc(5),
            w: '100%',
        },
        progressTrack: {
            flex: '1 0 0',
            h: remCalc(4),
            bg: 'border.disabled',
        },
        progressFill: {
            h: '100%',
            bg: 'background.dark',
            transition: 'width linear',
        },
        slide: {
            flex: '0 0 100%',
            w: '100%',
            h: '100%',
            position: 'relative',
        },
        slideTrack: {
            display: 'flex',
            position: 'absolute',
            top: 0,
            left: 0,
            h: '100%',
            w: '100%',
            transition: 'transform 420ms ease',
            willChange: 'transform',
        },
        slideContainer: {
            position: 'relative',
            w: '100%',
            h: '100%',
        },
        slideImage: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
        slideMask: {
            position: 'absolute',
            left: 0,
            right: 0,
            background: 'linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent)',
            zIndex: 1,
        },
        slideButtonContainer: {
            position: 'absolute',
            right: 0,
            bottom: 0,
            pb: remCalc(12),
            pr: remCalc(12),
        },
        slideTextBlock: {
            position: 'relative',
            zIndex: 2,
        },
    },
}
